module.exports = __webpack_public_path__ + "img/delete.97e2d487.svg";